<div class="wrapper">
  <header id="header">
    <div class="main-title">
      <div class="main-title d-flex justify-content-center align-items-center">
        <img src="./assets/images/lato-sensu-banner.png" alt="" class="image-auto"/>
      </div>
      <!-- <div class="locales-container">
        <div *ngFor="let locale of localesList">
          <a mat-icon-button title="{{locale.label}}" href="{{locale.path}}">
            <img src="{{locale.image}}" width="24" alt=""/>
          </a>
        </div>
      </div>       -->
    </div>
    <div class="main-subtitle">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6 p-3 d-flex flex-column align-items-center justify-content-center">
            <img src="./assets/images/lato-sensu-logo.png" alt="" class="image-auto"/>
            <div class="text-start">
              <p class="mt-3" style="text-align: justify;">A pós-graduação lato sensu, modalidade especialização, tem como objetivo completar e aprofundar a formação acadêmica do graduado, visando à educação continuada, à melhoria do perfil profissional e ao aprimoramento da atuação no mundo do trabalho, nos vários setores da sociedade, bem como ao desenvolvimento cultural, social e econômico do país. Os cursos serão ofertados na modalidade presencial, híbrida e/ou a distância, em conformidade com a legislação vigente do Ministério da Educação (MEC) e da Unesp.</p>
            </div>
          </div>
          <div class="col-12 col-lg-6 text-center p-3">
            <img src="./assets/images/lato-sensu-mapa-v2.png" alt="" class="image-auto"/>
          </div>
        </div>
      </div>
    </div>
    <div class="main-options">
      <div class="container">
        <div class="row docente-options">
          <div class="col-12 col-lg-6 text-center">
            <a class="btn btn-gradient-1" i18n="@@area_docente" href="lato-sensu#area-docente">
              Área do Docente
            </a>
          </div>
          <div class="col-12 col-lg-6 text-center">
            <button class="btn btn-gradient-2" (click)="openLink('https://app.unesp.br/sisesp/')" i18n="@@area_discente">
              Área do Discente
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
  @if (!loadFail) {
  <main>
    <div class="container mb-2 mt-3">
      <mat-accordion id="search">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>search</mat-icon> <span i18n="@@pesquisar">Pesquisar</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="form">
            <div class="row row-cols-12">
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@curso">Curso</mat-label>
                  <mat-icon matPrefix (click)="limpar('nomeCurso')" *ngIf="form.controls.nomeCurso.getRawValue()?.length">closed</mat-icon>
                  <input matInput type="text" i18n-placeholder="@@ph_curso" placeholder="Curso" [formControl]="form.controls.nomeCurso" [matAutocomplete]="auto" (keydown.enter)="validarFiltroNomeCurso()"/>
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                    <mat-option *ngFor="let curso of cursoFiltered | async" (onSelectionChange)="selecionarCurso(curso)" [value]="curso">
                      {{ curso }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@modalidade">Modalidade</mat-label>
                  <mat-icon matPrefix (click)="limpar('modalidade')" *ngIf="form.controls.modalidade.getRawValue()?.length">closed</mat-icon>
                  <mat-select formControlName="modalidade" (selectionChange)="pesquisar()">
                    <mat-option *ngFor="let modalidade of modalidades" [value]="modalidade">{{modalidade}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-3">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@cidade2">Cidade</mat-label>
                  <mat-icon matPrefix (click)="limpar('cidade')" *ngIf="form.controls.cidade.getRawValue()?.length">closed</mat-icon>
                  <mat-select formControlName="cidade" (selectionChange)="pesquisar()">
                    <mat-option *ngFor="let cidade of cidades" [value]="cidade">{{cidade}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </form>
        </mat-expansion-panel>
      </mat-accordion>

      @if (inscricaoAberta.length) {
        <h2 i18n="@@inscricoes_abertas">Inscrições abertas</h2>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
          <div class="col" *ngFor="let curso of inscricaoAberta; index as i;">
            <ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ curso: curso }"></ng-container>
          </div>
        </div>
      }

      @if (proximos.length) {
        <h2 i18n="@@proximos_cursos">Próximos cursos</h2>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
          <div class="col" *ngFor="let curso of proximos; index as i;">
            <ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ curso: curso }"></ng-container>
          </div>
        </div>
      }

      @if (emAndamento.length) {
        <h2 i18n="@@cursos_em_andamento">Cursos em andamento</h2>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
          <div class="col" *ngFor="let curso of emAndamento; index as i;">
            <ng-container [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{ curso: curso }"></ng-container>
          </div>
        </div>
      }

    </div>
  </main>
  } @else {
  <main>
    <div class="container mb-2 mt-3">
      <div class="alert alert-danger mt-3 pb-3 text-center" role="alert">
        <span i18n="@@loadFail">Não foi possível carregar as informações.</span>
      </div>
    </div>
  </main>
  }
  <div id="area-docente" class="mb-5">
    <div class="area-docente-barra">
      <div class="container mb-2 mt-3">
        <h4 i18n="@@area_docente">Área do Docente</h4>
      </div>
    </div>
    <div class="container mb-2 mt-3">
      <div class="row">
        <div class="p-3">
          <h5 i18n="@@docente-texto-1">Como fazer seu Primeiro Acesso</h5>
          <p i18n="@@docente-texto-2">O primeiro acesso ao SISESP deve ser feito com usuário e senha dos sistemas institucionais exclusivamente no endereço:</p>
          <a i18n="@@link-sisesp" href="https://app.unesp.br/sisesp/" target="_blank">https://app.unesp.br/sisesp/</a>
          <p i18n="@@docente-texto-3">Somente a partir dessa etapa, da realização do primeiro login, o SISESP estará apresentado na lista de sistemas da Central de Acessos.</p>
          <p i18n="@@docente-texto-4">Dúvidas sobre o SISESP (norma ou sistema) devem ser enviadas via SISESP em "Ajuda/Suporte".</p>
          <div class="docente-links">
            <div>
              <button mat-raised-button (click)="openLink('https://www2.unesp.br/portal#!/propg/sobre/legislacao20118/legislacoes-unesp/')" color="primary" i18n="@@fundamentacao_legal">Fundamentação Legal</button>
            </div>
            <div>
              <button mat-raised-button (click)="openCepg()" i18n="@@comissao_cepg">Comissão de Especialização (CEPG)</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="mt-auto">
    <div class="container">
      <address class="mb-0">
        <a href="https://www2.unesp.br/portal#!/propg" target="_blank" aria-label="Área responsável: PROPG" title="Área responsável: PROPG - Pró-reitoria de Pós-graduação">PROPG</a>
        |
        <a href="https://www2.unesp.br/portal#!/ctinf" target="_blank" aria-label="Proprietário: CTINF" title="Proprietário: CTINF - Coordenadoria de Tecnlogia da Informação">CTINF</a>
        |
        <a href="https://www2.unesp.br/portal#!/gtdsi" target="_blank" aria-label="Desenvolvido por: GTDSI" title="Desenvolvido por: GTDSI - Grupo Técnico de Desenvolvimento de Sistemas Institucionais">GTDSI</a>
      </address>
    </div>
  </footer>
</div>

<ng-template #cardTemplate let-curso="curso">
  <div class="card h-100">
    <div class="card-body d-flex flex-column">
      <p><b>{{curso.modalidade}}</b></p>
      @switch (curso.areaConhecimento) {
        @case ('1') { <img class="card-img" src="./assets/icons/lato-sensu-01.png" alt=""> }
        @case ('2') { <img class="card-img" src="./assets/icons/lato-sensu-02.png" alt=""> }
        @case ('3') { <img class="card-img" src="./assets/icons/lato-sensu-03.png" alt=""> }
        @case ('4') { <img class="card-img" src="./assets/icons/lato-sensu-04.png" alt=""> }
        @case ('5') { <img class="card-img" src="./assets/icons/lato-sensu-05.png" alt=""> }
        @case ('6') { <img class="card-img" src="./assets/icons/lato-sensu-06.png" alt=""> }
        @case ('7') { <img class="card-img" src="./assets/icons/lato-sensu-07.png" alt=""> }
        @case ('8') { <img class="card-img" src="./assets/icons/lato-sensu-08.png" alt=""> }
        @case ('9') { <img class="card-img" src="./assets/icons/lato-sensu-09.png" alt=""> }
      }
      <div class="titulo-curso">
        <h3>{{curso.nome}}</h3>
      </div>
      <div class="card-content">
        <p><b><span i18n="@@edicao">Edição</span>:</b> {{curso.edicao}}ª</p>
        <p><b><span i18n="@@local">Local</span>:</b> {{curso.cidade}}</p>
        <p><b><span i18n="@@duracao">Duração</span>:</b> {{curso.duracao}} <span i18n="@@meses">meses</span></p>
        <p><b><span i18n="@@carga_horaria">Carga horária</span>:</b> {{curso.cargaHoraria}} <span i18n="@@horas">horas</span></p>
      </div>
      <button mat-raised-button (click)="acessar(curso)" color="primary" class="btn-acessar" i18n="@@acesse_aqui">Acesse aqui</button>
    </div>
  </div>
</ng-template>